import { Catalog } from '@df/catalog/catalog.interfaces';
import { Model } from '@df/catalog/model';

export abstract class AbstractFinder<T extends Catalog.IFinderData = Catalog.IFinderData> extends Model<T, number> {
    get directions(): string | undefined {
        if (this.data && this.data.latitude && this.data.longitude) {
            return 'https://www.google.com/maps/dir/Current+Location/' + this.data.latitude + ',' + this.data.longitude;
        }
        return undefined;
    }

    getDistance(inMiles: boolean): number | string {
        if (!this.distance) {
            return '';
        }
        const distance: number | string = inMiles ? this.distance / 1.609344 : this.distance;

        if (distance > 10) {
            return Math.round(distance);
        } else if (distance > 1) {
            return distance.toFixed(1);
        } else {
            return distance.toFixed(2);
        }
    }

    get distance(): number | undefined {
        return this.data ? this.data.distance : undefined;
    }
}
